import React, { useEffect, useMemo, useRef, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useHistory, useLocation } from "react-router-dom";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Tooltip, Progress, FloatButton } from "antd";
import Xicon from "../../assets/icons/Xicon.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import calendar from "../../assets/icons/calendar.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import searchicon from "../../assets/icons/searchicon.svg";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Header from "../../layouts/Header";
import "../../assets/styles/local/AddProject.css";
import "../../assets/styles/local/NewInput.css";
import "../../assets/styles/local/with_img_SelectBox.css";
import AddDocuments from "./AddDocuments";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import CurrencyInput from "react-currency-input";

import {
  AddDocumentToProject,
  CreateProject,
  FetchActiveUser,
  FetchClient,
  Fetchlastprojectcode,
  changeProjectTab,
  fetchTranslationData,
  getAppSideBarOptions,
  GlobalRequest,
  FetchPaymentDeadline,
  FetchProjectBillingTerms,
  FetchClientContactsByclientId,
  AddProjectBillingTerms,
  DeleteProjectBillingTerms,
  FetchInvoiceSettingList,
} from "../../redux/actions/action";

import axios from "axios";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import AddInvoice from "../../components/Add_Project/AddInvoice";
import AddQuotes from "../../components/Add_Project/AddQuotes";
import AddStock from "../../components/Add_Project/AddStock";
import AddTask from "../../components/Add_Project/AddTask";
import Financial from "../../components/Add_Project/Financial";
import AppDatePicker from "../../components/Common/AppDatePicker";
import { API_URL, CREATE_PROJECT } from "../../redux/constants/type";
import Team from "../../components/Add_Project/Team";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import Proforma from "../../components/Add_Project/AddPerforma";
import { ROLES } from "../../utils/helpers/userRole";
import ProjectDocuments from "./ProjectDocuments";
import moment from "moment";
import AddTerms from "../../components/Add_Project/AddTerms";
import AddProjectHiring from "../../components/Add_Project/AddProjectHiring";
import AddProjectRent from "../../components/Add_Project/AddProjectRent";
import ProjectWork from "../../components/Add_Project/ProjectWork";
import AddMaterials from "../../components/Add_Project/AddMaterials";

const AddProject = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const initialRender = useRef(true);
  const Project_Popup_Ref = useRef(null);
  const hidden_Input_File = useRef(null);
  const projectManagerRef = useRef(null);
  const PaymentDeadline_Popup_Ref = useRef(null);
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const locationTab = location?.state?.tab;
  console.log("asc56 loc", location);
  const passedState = location.state;

  const isInterko = useMemo(() => {
    return (
      window.localStorage.getItem("companyid") ==
      "28830f30-b321-4662-a576-f23451677742"
    );
  }, []);

  const isPlus = useMemo(() => {
    return window.localStorage.getItem("hasPlus") == "true";
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const fetchAddProjectId = useSelector(
    (state) => state.user.fetchAddProjectId,
  );
  const createProject = useSelector((state) => state.user.createProject);
  const fetchClient = useSelector((state) => state.user.fetchClient);
  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const projectTab = useSelector((state) => state.user.projectTab);

  const GetProjectStatusDropdownListRes = useSelector(
    (state) => state.user.GetProjectStatusDropdownListRes,
  );
  const showAdvancedTaskSystem = useSelector(
    (state) => state.user.showAdvancedTaskSystem,
  );

  const fetchPaymentDeadline = useSelector(
    (state) => state.user.fetchPaymentDeadline,
  );

  const fetchBillingTermsRes = useSelector(
    (state) => state.user.fetchBillingTermsRes,
  );

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const fetchClientContactsByClientIdRes = useSelector(
    (state) => state.user.fetchClientContactsByClientIdRes,
  );

  const addNewBillingRes = useSelector((state) => state.user.addNewBillingRes);

  const deleteNewBillingRes = useSelector(
    (state) => state.user.deleteNewBillingRes,
  );

  const FetchInvoiceSettingListResponse = useSelector(
    (state) => state.user.FetchInvoiceSettingListResponse,
  );

  useEffect(() => {
    dispatch(FetchInvoiceSettingList(companyId));
  }, []);

  useEffect(() => {
    if (FetchInvoiceSettingListResponse?.status === true) {
    }
  }, [FetchInvoiceSettingListResponse]);

  //////////////  VARIABLES START //////////////
  const [canGoBack, setCanGoBack] = useState(false);

  const [apimessage, setApimessage] = useState("");
  const [typeComp, setTypeComp] = useState("");
  const [tab, setTab] = useState("");

  const [projectNameWarning, setProjectNameWarning] = useState(false);
  const [deliveryAddressWarning, setDeliveryAddressWarning] = useState(false);
  const [clientNameWarning, setClientNameWarning] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [mainContact, setMainContact] = useState("");
  const [mainContactID, setMainContactID] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [client, setClient] = useState("");
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);

  const [startingDate, setStartingDate] = useState(new Date());
  const [completionDate, setCompletionDate] = useState(new Date());
  const [notes, setNotes] = useState("");
  // const [ add_image, setAdd_image ] = useState("");

  // main contact dropDown start
  const [mainContactData, setMainContactData] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserID, setSelectedUserID] = useState("");
  const [mainContactDataOpen, setMainContactDataOpen] = useState(false);
  // main contact dropDown end

  const [clientData, setClientData] = useState([]);
  const [clientid, setClientid] = useState("");
  const [clientType, setClientType] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [professionalAddress, setProfessionalAddress] = useState("");
  const [personalAddress, setPersonalAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [addressWithPinCode, setAddressWithPinCode] = useState("");
  const [deliveryAddressParts, setDeliveryAddressParts] = useState({
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [clientName, setClientName] = useState("");

  const [projectIdCode, setProjectIdCode] = useState("");
  const [projectManagerData, setProjectManagerData] = useState([]);
  const [managerFirstName, setManagerFirstName] = useState("");
  const [managerLastname, setManagerLastname] = useState("");
  const [projectManagerid, setProjectManagerid] = useState("");
  const [managerAbbreviation, setManagerAbbreviation] = useState("");
  const [managerImageurl, setManagerImageurl] = useState("");
  const [projectid2, setProjectid2] = useState("");
  const [projectStatusList, setProjectStatusList] = useState([]);

  const [managerShowBox, setManagerShowBox] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [dateError, setDateError] = useState(false);

  const [isPlusMember, setIsPlusMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const [statusPipeLineLabel, setStatusPipeLineLabel] = useState("");

  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState(false);
  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [paymentDeadlineOptions, setPaymentDeadlineOptions] = useState(false);
  const [paymentOthersOptions, setPaymentOthersOptions] = useState(false);
  const [paymentDeadlineData, setPaymentDeadlineData] = useState([]);
  const [paymentDeadlineid, setPaymentDeadlineid] = useState("");
  const [paymentDeadline, setPaymentDeadline] = useState("");
  const [dueDays, setDueDays] = useState("");
  const [description, setDescription] = useState("");

  const [creditLimit, setCreditLimit] = useState("");
  const [creditBalance, setCreditBalance] = useState("");
  const [creditStatus, setCreditStatus] = useState(true);

  const [showBillingOption, setShowBillingOption] = useState(false);
  const [billingData, setBillingData] = useState([]);
  const [searchBillingName, setSearchBillingName] = useState("");
  const [billingName, setBillingName] = useState("");
  const [billingID, setBillingID] = useState("");
  const [needPO, setNeedPO] = useState(true);
  const [numberOfWeeks, setNumberOfWeeks] = useState(0);

  const [addBilling, setAddBilling] = useState("");
  const [addBillingInputShow, setAddBillingInputShow] = useState(false);

  const [val, setVal] = useState("");
  const [isBasicMember, setIsBasicMember] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [modalFunction, setModalFunction] = useState("add");
  const [taskid, setTaskid] = useState("");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [show, setShow] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // asc Number OF Weeks start.
  useEffect(() => {
    const start = moment(startingDate);
    const end = moment(completionDate);

    const daysDifference = end.diff(start, "days");
    const getNumberOfWeeks = Math.ceil(daysDifference / 7);

    setNumberOfWeeks(getNumberOfWeeks);
  }, [startingDate, completionDate]);

  console.log("asc5678", numberOfWeeks);

  const calculateNo_Of_Weeks = () => {
    const start = moment(startingDate);
    const end = moment(completionDate);

    const daysDifference = end.diff(start, "days");
    const getNumberOfWeeks = Math.ceil(daysDifference / 7);

    setNumberOfWeeks(getNumberOfWeeks);
  };
  // asc Number OF Weeks end.

  const emailInvalid22 = new RegExp(
    "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
  );

  useEffect(() => {
    setTab(projectTab);
  }, [projectTab]);

  // useEffect(() => {
  //   if (location?.state?.from === "Add_Company_Screen_ForProject") {
  //     setTab("General");
  //   } else {
  //     setTab(projectTab);
  //   }
  // }, [projectTab]);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const hasPackagePlus = getAppSideNavOptions.some(
        (x) =>
          x.packageName.toUpperCase() == "PLUS" ||
          x.packageId == process.env.REACT_APP_IS_PREMIUM,
      );
      setIsPlusMember(hasPackagePlus);

      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const statusOption1 = [
    {
      id: "1",
      label: "Info Request",
      value: process.env.REACT_APP_PROJECT_INFO_REQUEST,
    },
    {
      id: "2",
      label: "Quote Request",
      value: process.env.REACT_APP_PROJECT_QUOTE_REQUEST,
    },
    {
      id: "3",
      label: "Quoted",
      value: process.env.REACT_APP_PROJECT_QUOTED,
    },
    {
      id: "4",
      label: "Won Projects",
      value: process.env.REACT_APP_PROJECT_WON_PROJECT,
    },
    {
      id: "5",
      label: "For Production",
      value: process.env.REACT_APP_PROJECT_FOR_PODUCTION,
    },
    {
      id: "6",
      label: "Archived",
      value: process.env.REACT_APP_PROJECT_ARCHIVED,
    },
  ];
  const statusOption = [
    {
      id: "1",
      label: "Sales Pipeline",
      value: process.env.REACT_APP_PROJECT_SALES_PIPELINE,
    },
    {
      id: "2",
      label: "Won Projects",
      value: process.env.REACT_APP_PROJECT_WON_PROJECT,
    },
    {
      id: "3",
      label: "For Production",
      value: process.env.REACT_APP_PROJECT_FOR_PODUCTION,
    },
    {
      id: "4",
      label: "Archived",
      value: process.env.REACT_APP_PROJECT_ARCHIVED,
    },
  ];
  const [dataBind, setDataBind] = useState({});
  const [statusPipeLine, setStatusPipeLine] = useState(
    isPlusMember
      ? process.env.REACT_APP_PROJECT_SALES_PIPELINE
      : process.env.REACT_APP_PROJECT_INFO_REQUEST,
  );

  useEffect(() => {
    setStatusPipeLine(
      isPlusMember
        ? process.env.REACT_APP_PROJECT_SALES_PIPELINE
        : process.env.REACT_APP_PROJECT_INFO_REQUEST,
    );
  }, [isPlusMember]);

  // FETCH Add project Id Code START //
  useEffect(() => {
    dispatch(Fetchlastprojectcode());
    dispatch(getAppSideBarOptions());
    return () => setCanGoBack(false);
  }, []);

  let initial = true;

  useEffect(() => {
    if (fetchAddProjectId.status === true) {
      setProjectIdCode(fetchAddProjectId.data);
    } else {
      setApimessage(fetchAddProjectId?.message);
    }
  }, [fetchAddProjectId]);

  // FETCH Add project Id Code END //

  ////////// ASC FOR CLIENTID RESPONCE. START //////////

  useEffect(() => {
    dispatch(FetchClient());
    dispatch(FetchPaymentDeadline());
    dispatch(FetchProjectBillingTerms());
  }, [addNewBillingRes, deleteNewBillingRes]);

  // asc fetch payment Deadline Responce start //
  useEffect(() => {
    if (fetchPaymentDeadline?.status === true) {
      const deadlineLabel =
        FetchInvoiceSettingListResponse?.data?.[0]?.paymentDeadline;

      setPaymentDeadline(deadlineLabel);

      const matchedDeadline = fetchPaymentDeadline?.data?.find(
        (item) => item.paymentDeadline === deadlineLabel,
      );

      if (matchedDeadline) {
        setPaymentDeadlineid(matchedDeadline.paymentDeadlineid);
      }

      setPaymentDeadlineData(fetchPaymentDeadline?.data);
    }
  }, [fetchPaymentDeadline, FetchInvoiceSettingListResponse]);
  // asc fetch payment Deadline Responce end //

  // asc fetch billing ters Responce start //
  useEffect(() => {
    if (fetchBillingTermsRes?.status === true) {
      setBillingData(fetchBillingTermsRes?.data);
    }
  }, [fetchBillingTermsRes]);
  // asc fetch billing ters Responce end //

  useEffect(() => {
    if (fetchClient.status === true) {
      // setApimessage(fetchClient.message)
      setClientData(fetchClient.data);
      setClientType(fetchClient.data[0]?.type);
    } else {
      // setApimessage(fetchClient?.message);
    }
  }, [fetchClient]);

  ////////// ASC FOR CLIENTID RESPONCE. END ///////////

  useEffect(() => {
    if (fetchClientContactsByClientIdRes.status === true) {
      setMainContactData(fetchClientContactsByClientIdRes.data);
    }
  }, [fetchClientContactsByClientIdRes]);

  ////////// ASC FOR PROJECTS MANAGER ID. START /////////

  useEffect(() => {
    dispatch(FetchActiveUser(companyId));
    window.localStorage.removeItem("projectcode");
    window.localStorage.removeItem("projectname");
    window.localStorage.removeItem("projectid");
  }, []);

  useEffect(() => {
    if (fetchActiveUser.status === true) {
      // setApimessage(fetchActiveUser?.message)
      setProjectManagerData(fetchActiveUser.data);
    } else {
      setApimessage(fetchActiveUser?.message);
    }
  }, [fetchActiveUser]);

  ////////// ASC FOR PROJECTS MANAGER ID. END //////////

  //////////// ASC ADD PROJECT API START /////////////

  const [emailInvalid, setEmailInvalid] = useState(false);

  const [priorityId, setPriorityId] = useState("");

  const handleProjectAdd = () => {
    setTypeComp("");
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let trimText = projectName.trim();

    if (trimText === "") {
      setProjectNameWarning(true);
    }
    if (deliveryAddress === "" && addressWithPinCode === "") {
      setDeliveryAddressWarning(true);
    }
    if (searchName === "") {
      setClientNameWarning(true);
    }
    if (!re.test(contactEmail) && contactEmail) {
      setEmailInvalid(true);
    }
    if (
      trimText === "" ||
      (deliveryAddress === "" && addressWithPinCode === "") ||
      searchName === "" ||
      (!re.test(contactEmail) && contactEmail)
    ) {
      return;
    } else {
      dispatch(
        CreateProject(
          userId,
          projectName,
          clientid ? clientid : null,
          contactEmail,
          contactTelephone,
          completionDate,
          statusPipeLine,
          projectManagerid ? projectManagerid : null,
          // deliveryAddress, old address without zip code.
          addressWithPinCode,
          mainContact,
          add_image,
          notes,
          priorityId,
          projectDescription,
          startingDate,
          numberOfWeeks,
          needPO,
          billingID,
          // paymentDeadline,
          paymentDeadlineid,
          Number(creditLimit),
          creditBalance,
          creditStatus,
          deliveryAddressParts,
        ),
      );
      setCanGoBack(true);
      window.localStorage.removeItem("clientid");
      window.localStorage.removeItem("clientname");
    }
  };

  useEffect(() => {
    const handleSuccessfulCreate = () => {
      // setSalesPipeLineData(createProject?.data[0]?.projectstatus);
      setProjectid2(createProject?.data.projectid);
      // if (dataBind.length > 0) {
      // setTimeout(() => {
      // dispatch(
      //   AddDocumentToProject(userId, createProject?.data.projectid, dataBind)
      // );
      // }, 2000);
      // }

      setTimeout(() => {
        // history.push("/project");
        // history.goBack(); // for go back after Add project.
        // window.location.reload();
        if (localStorage.getItem("projectOnTheFly")) {
          history.push("/project");
        } else {
          history.goBack(); // for go back after Add project.
        }
      }, 1000);

      dispatch({
        type: CREATE_PROJECT,
        data: {},
      });

      setTimeout(() => {
        localStorage.removeItem("projectOnTheFly");
      }, 3000);
    };

    const handleFailedCreate = () => {
      setApimessage(createProject?.message);
      setTimeout(() => {
        setApimessage("");
      }, 5000);
    };

    if (createProject?.status === true) {
      handleSuccessfulCreate();
    } else {
      handleFailedCreate();
    }
  }, [createProject]);

  ///////////// ASC ADD PROJECT API END ///////////

  ///////////// ASC INPUT FILE START ///////////////

  const handleIMGClick = () => {
    hidden_Input_File.current.click();
  };

  const [myImgData, setMyImgData] = useState([]);
  const [isError, setIsError] = useState("");
  const [add_image, setAdd_image] = useState("");

  // using Async Await
  const handleFileUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    const formData = new FormData();
    formData.append("file", fileUploaded);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // if (response !== null) {
      //     setAdd_image(response.data[ 0 ]);
      //     setAttachMessage(
      //         target.name + " " + "File is Attached in comment box"
      //     );
      //     setShowError(true);
      // } else {
      // }
      setMyImgData(response.data);
      setAdd_image(response.data[0]);
    } catch (error) {
      console.error(error);
      setIsError(error.message);
    }
  };

  ////////////////// ASC INPUT FILE END /////////////////

  //////////////ASC FOR CUSTOM SELECT BOX START //////////

  const [showOptions, setShowOptions] = useState(false);

  const onInputFocus = () => {
    setShowOptions(true);
  };

  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    // when we come from companyList.
    if (location?.ascState?.from === "CompanyList_Screen") {
      setSearchName(location?.ascState?.clientName);
      setClientid(location?.ascState?.clientId);
      setAddressWithPinCode(location?.ascState?.clientAddress);
    }
  }, []);

  //////////////ASC FOR CUSTOM SELECT BOX END //////////

  ///////////// ASC WITH IMG SELECT BOX START //////////

  const [showplusCircle, setShowplusCircle] = useState(true);
  const [showImgCircle, setShowImgCircle] = useState(false);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [assignee, setAssignee] = useState([]);
  const [searchPeople, setSearchPeople] = useState("");

  useEffect(() => {
    if (showImgCircle === true) setShowplusCircle(false);
  });

  ///////////// ASC WITH IMG SELECT BOX END //////////

  ///////////// ASC FOR MODAL POPUP START //////////

  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);

  const handleCancel = (e) => {
    // history.push("/project");
    history.goBack();
  };
  ///////////// ASC FOR MODAL POPUP END //////////

  useEffect(() => {
    if (location.state === "/project") {
      dispatch(changeProjectTab("General"));
    } else if (location?.state?.from === "Add_Company_Screen_ForProject") {
      dispatch(changeProjectTab("General"));
    } else if (locationTab && locationTab === "Invoice") {
      dispatch(changeProjectTab("Invoice"));
    } else {
      dispatch(changeProjectTab("Team"));
    }
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetProjectStatusDropdownList`,
        method: "get",
        data: {},
        state: "GetProjectStatusDropdownListRes",
      }),
    );
  }, []);

  useEffect(() => {
    if (GetProjectStatusDropdownListRes?.status === true) {
      setProjectStatusList(GetProjectStatusDropdownListRes?.data);
      const data = GetProjectStatusDropdownListRes?.data;
      if (data != null && Array.isArray(data) && Array.from(data).length > 0) {
        let firstItem = data[0];
        setStatusPipeLineLabel(firstItem?.statusName);
        setStatusPipeLine(firstItem?.statusId);
      }
    }
  }, [GetProjectStatusDropdownListRes]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const clientPopRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      projectManagerRef.current &&
      !projectManagerRef.current.contains(event.target)
    ) {
      setShowDropPeople(false);
    }

    if (
      PaymentDeadline_Popup_Ref.current &&
      !PaymentDeadline_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentDeadlineOptions(false);
      setArrowOptionsRotate4(false);
    }

    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }

    if (clientPopRef.current && !clientPopRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // ASC address with postal code start
  const getAddressParts = (parsed = {}) => ({
    street: parsed.streetWithNumber || parsed.street || "",
    city: parsed.city || "",
    state: parsed.state || "",
    pinCode: parsed.pinCode || parsed.postalCode || "",
    country: parsed.country || "",
  });

  const handleAddressSelect = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);

      setAddressWithPinCode(parsed.formattedAddress); // Store full Google address.
      setZipCode(parsed.postalCode); // Store only postal code.
      setDeliveryAddressParts(getAddressParts(parsed));
      console.log("final address", parsed.formattedAddress);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end

  // current location address start
  const getCurrentLocationAddress = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const apiKey = "AIzaSyBcYRPNB_ePlSHVxC1p5buVrxdL_Uou_bc"; // YOUR_GOOGLE_API_KEY

          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`,
            );
            const data = await response.json();

            if (data.status === "OK" && data.results.length > 0) {
              const { formatted_address, address_components } = data.results[0];
              const postalCode =
                address_components.find((x) => x.types.includes("postal_code"))
                  ?.long_name || "";

              setAddressWithPinCode(formatted_address); // Full address
              setZipCode(postalCode); // Postal code only
              setDeliveryAddressParts({
                street: "",
                city: "",
                state: "",
                pinCode: postalCode,
                country: "",
              });

              console.log("Current Location Address:", formatted_address);
            } else {
              console.error("❌ No address found for current location.");
            }
          } catch (error) {
            console.error("❌ Error fetching current location address:", error);
          }
        },
        (error) => {
          console.error("❌ Geolocation error:", error.message);
        },
      );
    } else {
      alert("❌ Geolocation not supported by this browser.");
    }
  };
  // getCurrentLocationAddress();
  // current location address end

  const handleTabChange = (tab) => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let trimText = projectName.trim();

    if (trimText === "") {
      setProjectNameWarning(true);
    } else if (deliveryAddress === "" && addressWithPinCode === "") {
      setDeliveryAddressWarning(true);
    } else if (searchName === "") {
      setClientNameWarning(true);
    } else if (!re.test(contactEmail) && contactEmail) {
      setEmailInvalid(true);
    } else {
      dispatch(changeProjectTab(tab));
    }
  };

  useEffect(() => {
    // when we come from AddCompany screen.
    if (location?.state?.from === "Add_Company_Screen_ForProject") {
      setSearchName(passedState?.historyCompanyName);
      setClientid(passedState?.historyCompanyID);
      setAddressWithPinCode(passedState?.historyDeliveryAddress);
      if (passedState?.historyDeliveryAddressParts) {
        setDeliveryAddressParts(passedState.historyDeliveryAddressParts);
      }
      setCreditLimit(passedState?.historyCreditLimit);
    }
  }, []);

  // const [subTab, setSubTab] = useState("Terms");
  const [subTab, setSubTab] = useState("Proforma");
  const handleSubTabChange = (subTabName) => {
    setSubTab(subTabName);
  };

  const [subTab2, setSubTab2] = useState("Stock");
  const handleSubTabChange2 = (subTabName) => {
    setSubTab2(subTabName);
  };

  // add new billing function start👇
  const handleAddNewBilling = () => {
    if (!addBilling) {
      return;
    }
    dispatch(AddProjectBillingTerms(addBilling));
  };

  useEffect(() => {
    if (addNewBillingRes.status === true) {
      setAddBilling("");
    }
  }, [addNewBillingRes]);

  const [useCurrentLocation, setUseCurrentLocation] = useState(false);

  return (
    <>
      <Header
        leftComponent={
          <div className="flex-wrap gap-4 d-flex align-items-baseline">
            <div
              className="projectText"
              onClick={() => {
                history.push("/project");
              }}
            >
              {/* Projects */}
              {t("Projects")}
            </div>
            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 projectText2">
                {/* Project */}
                {t("Project")}
              </p>
              <p className="pt-1 projectID ps-5"> ID &nbsp;{projectIdCode} </p>
            </div>
          </div>
        }
      />
      <RouteLeavingGuard
        when={typeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // This case it blocks the navigation when:
          // 1. the login form is dirty, and
          // 2. the user is going to 'sign-up' scene.
          //    (Just an example, in real case you might
          //     need to block all location regarding this case)
          if (typeComp !== "") {
            if (
              ![
                "/quote-calculation",
                "/addProject",
                "/NewInvoice",
                "/add-purchasing-order",
              ].includes(location.pathname)
            ) {
              if (location.pathname === "/project" && !canGoBack) {
                return true;
              } else if (location.pathname === "/project" && canGoBack)
                return false;
              return true;
            }
          }
          return false;
        }}
      />

      {/* {modalShow && (
        <CancelWarningModal
          show={modalShow}
          // onHide={() => setModalShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )} */}

      <div
        style={{
          background: "#FAFAFA",
        }}
        className="container-fluid"
      >
        {/* <div
                    className='flex-wrap gap-3 d-flex justify-content-center justify-content-sm-center justify-content-md-end justify-content-lg-end justify-content-xl-end justify-content-xxl-end pe-5'
                >
                    <button
                        type="button"
                        className="btn addProCancel"
                        onClick={() => {
                            if (typeComp !== "") {
                                setModalShow(true);
                            } else {
                                history.goBack();
                            }
                            // setModalShow(true);
                            // history.goBack();
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn addProAdd"
                        // className={
                        //     projectName === "" ||
                        //         clientid === "" ||
                        //         add_image === "" ||
                        //         projectManagerid === "" ?

                        //         "btn beforeProAdd"
                        //         : "btn addProAdd"
                        // }

                        // disabled={
                        //     projectName === "" ||
                        //     clientid === "" ||
                        //     add_image === "" ||
                        //     projectManagerid === ""
                        // }

                        onClick={handleProjectAdd}
                    >
                        Add
                    </button>
                </div> */}

        <div className="flex-wrap d-flex justify-content-end pe-5">
          <div className="buttons-desktop d-flex align-items-center">
            <button
              type="button"
              className="addProCancel me-4"
              onClick={() => {
                // if (typeComp !== "") {
                //   setModalShow(true);
                // } else {
                history.goBack();
                // }
                // setModalShow(true);
                // history.goBack();
              }}
            >
              {/* Cancel */}
              {t("Cancel ")}
            </button>

            <button
              type="button"
              className="addProAdd"
              onClick={handleProjectAdd}
            >
              {/* Add */}

              {/* {showLoader ? (
                                <div className="gap-1 d-flex justify-content-center align-items-center">
                                    <div className="spinner-border spinner-border-sm" role="status"></div>
                                    <span>Adding...</span>
                                </div>
                            ) : (
                                // "Add"
                            )} */}

              {/* "Add" */}
              {t("Add")}
            </button>
          </div>
        </div>

        {/* <div className="d-flex justify-content-around"> */}
        <div className="project_scrollWidth">
          <div className="pt-4 text-center row mainBoxDiv">
            <div
              className={`col-1 ${
                tab === "General" ? "box-highlighter" : "box-non-highlighter"
              }`}
              onClick={() => handleTabChange("General")}
            >
              {/* <p>General</p> */}
              <p>{t("General")}</p>
              <hr
                className={
                  tab === "General" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>

            <div
              className={`col-1 ${
                tab === "Document" ? "box-highlighter" : "box-non-highlighter"
              }`}
              onClick={() => handleTabChange("Document")}
            >
              {/* <p>Documents</p> */}
              <p>{t("Docs & Photos")}</p>
              <hr
                className={
                  tab === "Document" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>

            {companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" && (
              <div
                className={`col-1 ${
                  tab === "Quote" ? "box-highlighter" : "box-non-highlighter"
                }`}
                onClick={() => {
                  handleTabChange("Quote");
                  // setTypeComp("");
                }}
              >
                {/* <p>Quotes</p> */}
                <p>{t("Quotes")}</p>
                <hr
                  className={
                    tab === "Quote" ? "horizontalBarPro" : "horizontalBar"
                  }
                />
              </div>
            )}

            <div
              className={`col-1 d-none ${
                tab === "Materials" ? "box-highlighter" : "box-non-highlighter"
              }`}
              onClick={() => handleTabChange("Materials")}
            >
              <p>
                {/* Materials */}
                {t("Materials")}
              </p>
              <hr
                className={
                  tab === "Materials" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>

            <div
              className={`col-1 ${
                tab === "Task"
                  ? "box-highlighter d-none"
                  : "box-non-highlighter d-none"
              }`}
              onClick={() => handleTabChange("Task")}
            >
              {/* <p>Tasks</p> */}
              <p>{t("Task")}</p>
              <hr
                className={
                  tab === "Task" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>

            <div
              className={`col-1 ${
                tab === "Work" ? "box-highlighter" : "box-non-highlighter"
              }`}
              onClick={() => handleTabChange("Work")}
            >
              <p>
                {/* Work */}
                {t("Work")}
              </p>
              <hr
                className={
                  tab === "Work" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>

            {/* {companyId !== "28830f30-b321-4662-a576-f23451677742" &&
              companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" &&
              ((!Boolean(isInterko) && roleAccess !== ROLES.VIEWER) ||
                !isPlus) && (
                <div
                  className={`col-1 ${
                    tab === "Proforma"
                      ? "box-highlighter"
                      : "box-non-highlighter"
                  } hide-on-mobile hide-on-tablet`}
                  onClick={() => handleTabChange("Proforma")}
                >
                  <p>Proforma</p>
                  <hr
                    className={
                      tab === "Proforma" ? "horizontalBarPro" : "horizontalBar"
                    }
                  />
                </div>
              )} */}

            {/* {roleAccess !== process.env.REACT_APP_IS_VIEWER &&
              companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" && (
                <div
                  className={`col-1 ${
                    tab === "Invoice"
                      ? "box-highlighter"
                      : "box-non-highlighter"
                  }`}
                  onClick={() => handleTabChange("Invoice")}
                >
                  <p>{FetchTranslationList[13]?.translation}</p>
                  <hr
                    className={
                      tab === "Invoice" ? "horizontalBarPro" : "horizontalBar"
                    }
                  />
                </div>
              )} */}

            {/* Gaurav code for Sub Tab invoice and proforma start */}
            {companyId !== "28830f30-b321-4662-a576-f23451677742" &&
              companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" &&
              ((!Boolean(isInterko) && roleAccess !== ROLES.VIEWER) ||
                !isPlus) && (
                <div
                  className={`col-1 ${
                    tab === "Invoice and Proformas"
                      ? "box-highlighter"
                      : "box-non-highlighter"
                  } hide-on-mobile hide-on-tablet`}
                  onClick={() => handleTabChange("Invoice and Proformas")}
                >
                  <p>
                    {/* Invoice & <br /> Proformas */}

                    {t("Invoice & Proformas").slice(0, 9)}
                    <br />
                    {t("Invoice & Proformas").slice(9)}
                  </p>
                  <hr
                    className={
                      tab === "Invoice and Proformas"
                        ? "horizontalBarPro"
                        : "horizontalBar"
                    }
                  />
                </div>
              )}

            <div
              className={`col-1 ${
                tab === "Stock" ? "box-highlighter" : "box-non-highlighter"
              }`}
              onClick={() => handleTabChange("Stock")}
            >
              <p>
                {/* Purchase, <br />
                Rent & Hiring */}

                {t("Purchase, Rent & Hiring").slice(0, 9)}
                <br />
                {t("Purchase, Rent & Hiring").slice(9)}
              </p>
              <hr
                className={
                  tab === "Stock" ? "horizontalBarPro" : "horizontalBar"
                }
              />
            </div>
            {/* Gaurav code for Sub Tab invoice and proforma End */}

            {roleAccess !== process.env.REACT_APP_IS_VIEWER &&
              roleAccess !== process.env.REACT_APP_IS_USER &&
              companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" && (
                <div
                  className={`col-1 ${
                    tab === "Financial"
                      ? "box-highlighter"
                      : "box-non-highlighter"
                  }`}
                  onClick={() => handleTabChange("Financial")}
                >
                  <p>{t("Financial")}</p>
                  <hr
                    className={
                      tab === "Financial" ? "horizontalBarPro" : "horizontalBar"
                    }
                  />
                </div>
              )}

            {roleAccess !== process.env.REACT_APP_IS_VIEWER &&
              roleAccess !== process.env.REACT_APP_IS_USER &&
              companyId !== "e509224a-b2d2-408b-b07b-0d03286449dd" &&
              !isPlus && (
                <div
                  className={`col-1 ${
                    tab === "Team" ? "box-highlighter" : "box-non-highlighter"
                  } hide-on-mobile hide-on-tablet`}
                  style={{ padding: "20px 40px 0px 40px" }}
                  onClick={() => handleTabChange("Team")}
                >
                  <p>
                    {/* Planning */}
                    {t("Planning ")}
                  </p>
                  <hr
                    className={
                      tab === "Team" ? "horizontalBarPro" : "horizontalBar"
                    }
                  />
                </div>
              )}
          </div>

          <div className="container-fluids scrollWidth33">
            {/* ////////// ASC GENERAL BOX START //////////// */}

            {tab === "General" && (
              <div
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "row inner-highlighter pointerEvent verticallymobileview"
                    : "row inner-highlighter verticallymobileview"
                }
                style={{
                  borderTopLeftRadius: "0px",
                }}
              >
                <div className="col-4 mobile-full-width">
                  <div className="asc-input-container" id="ascInput">
                    {/* <label className={projectName ? 'label-top' : ''}>Project Name</label> */}
                    <label className="asc-label-top projectNameText">
                      {/* Project Name */}
                      <span>{t("Project Name")}</span>
                      <span className="mandatory-sign">*</span>
                    </label>
                    <input
                      type="text"
                      className={
                        projectNameWarning
                          ? "warning-border ps-4 bordered-inputs"
                          : "projectNameInput ps-4 bordered-inputs"
                      }
                      // placeholder="Add a title"
                      placeholder={t("Add a title")}
                      value={projectName}
                      onChange={(e) => {
                        setProjectName(e.target.value);
                        setTypeComp(e.target.value);
                        setProjectNameWarning(false);
                      }}
                    />
                  </div>

                  {projectNameWarning && (
                    <h6 className="warningText">
                      {/* Please enter project name */}
                      {t("Please enter project name\n")}
                    </h6>
                  )}

                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText z-3">
                      {/* Project Description */}
                      {t("Project Description")}
                    </label>

                    <textarea
                      style={{
                        height: "50px",
                        position: "relative",
                        zIndex: 2,
                      }}
                      id="w3review"
                      name="w3review"
                      rows="4"
                      cols="50"
                      // placeholder="Project Description"
                      className="notesInput ps-3 bordered-inputs"
                      value={projectDescription}
                      onChange={(e) => {
                        setProjectDescription(e.target.value);
                        // setChangeComp(e.target.value);
                      }}
                    ></textarea>
                  </div>

                  <div
                    className="asc-input-container extra_margin_asc_input_container"
                    id="ascInput"
                  >
                    <div
                      style={{
                        position: "relative",
                        borderRadius: "5px",
                        border: deliveryAddressWarning
                          ? "0.5px solid red"
                          : "1px solid #70707080",
                        padding: "10px",
                        height: "80px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          position: "absolute",
                          top: "-10px",
                          left: "10px",
                          color: "#7E7E7E",
                          backgroundColor: "#fff",
                          padding: "0 5px",
                        }}
                      >
                        {/* Delivery Address */}
                        {t("Delivery Address")}
                        <span className="mandatory-sign">*</span>
                      </label>

                      <label
                        className="d-flex"
                        style={{
                          fontSize: "12px",
                          position: "absolute",
                          top: "-10px",
                          left: "255px",
                          color: "#7E7E7E",
                          backgroundColor: "#fff",
                          padding: "0 5px",
                        }}
                      >
                        <div
                          className="company-radio-btn me-2"
                          style={{
                            pointerEvents: "auto",
                            backgroundColor: useCurrentLocation
                              ? "#00246A"
                              : "transparent",
                          }}
                          onClick={() => {
                            if (useCurrentLocation === false) {
                              setUseCurrentLocation(true);
                              // setAddress(previousAddress);
                              setTypeComp("asc");
                              // return;
                            }
                            getCurrentLocationAddress();
                            setUseCurrentLocation(!useCurrentLocation);
                            setTypeComp("asc");
                          }}
                        ></div>
                        {/* Current Address */}
                        {t(" Current Address")}
                        <span className="mandatory-sign">*</span>
                      </label>
                      <GooglePlacesAutocomplete
                        debounce={800}
                        renderInput={(props) => (
                          <textarea
                            rows="4"
                            className="DeliveryInput ps-3 bordered-inputs"
                            cols="50"
                            style={{
                              border: "none",
                              width: "100%",
                              // overflow: "hidden",
                              height: "65px",
                            }}
                            {...props}
                            onChange={(e) => {
                              props.onChange?.(e);
                              setDeliveryAddressParts({
                                street: "",
                                city: "",
                                state: "",
                                pinCode: "",
                                country: "",
                              });
                            }}
                            placeholder={t("Add a address")}
                          />
                        )}
                        onSelect={(e) => {
                          handleAddressSelect(e);
                          setDeliveryAddressWarning(false);
                          setTypeComp("asc");
                        }}
                        // initialValue={deliveryAddress}
                        initialValue={addressWithPinCode}
                        placeholder={t("Add a address")}
                      />
                    </div>
                    {/* <label className="asc-label-top projectNameText">
                      {FetchTranslationList[22]?.translation}
                    </label> */}

                    {/* <textarea
                      id="w3review"
                      name="w3review"
                      rows="4"
                      cols="50"
                      className="DeliveryInput ps-4"
                      placeholder={FetchTranslationList[23]?.translation}
                      value={deliveryAddress}
                      onChange={(e) => {
                        // setChangeComp(e.target.value);
                        setDeliveryAddress(e.target.value);
                      }}
                    ></textarea> */}
                  </div>

                  {deliveryAddressWarning && (
                    <h6 className="warningText">
                      {/* Please enter project delivery address */}
                      {t("Please enter project delivery address")}
                    </h6>
                  )}

                  <div className="mt-4">
                    <div className="addPicture22 marginGap" id="ascInput">
                      <div
                        className={add_image ? "" : "flexProperty mt-5 pt-2"}
                      >
                        {add_image ? (
                          <img
                            src={add_image}
                            className="addImg"
                            alt=""
                            style={{ height: "170px" }}
                          />
                        ) : (
                          <img
                            src={plusCircle}
                            className="plusImg"
                            alt=""
                            onClick={handleIMGClick}
                          />
                        )}

                        <input
                          multiple
                          type="file"
                          accept="image/*"
                          ref={hidden_Input_File}
                          style={{ display: "none" }}
                          onChange={(e) => {
                            // const fileUploaded = e.target.files[ 0 ];

                            // const imageLoaded = URL.createObjectURL(fileUploaded);
                            // setAdd_image(imageLoaded)

                            handleFileUpload(e);
                            // setChangeComp(e.target.value);
                          }}
                        />
                      </div>

                      <p className={add_image ? "d-none" : "Picture"}>
                        {/* Add picture */}
                        {t("Add picture")}
                      </p>
                    </div>

                    {/* <div className={add_image ? "deltImg" : "deltImgHidden"}>
                      {add_image && (
                        <>
                          <p className="pt-1">Remove picture</p>
                          <img
                            src={DeleteIcon}
                            className="pb-2 pointer"
                            alt=""
                            onClick={() => {
                              setAdd_image("");
                            }}
                          />
                        </>
                      )}
                    </div> */}

                    <div className="extra_margin">
                      <div className={add_image ? "deltImg" : "deltImgHidden"}>
                        <p className="pt-1">
                          {/* Remove picture */}
                          {t("Remove picture\n")}
                        </p>
                        <img
                          src={DeleteIcon}
                          className="pb-2 pointer"
                          alt=""
                          onClick={() => {
                            setAdd_image("");
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="asc-input-container" id="ascInput">
                    <label
                      style={{
                        marginTop: "6px",
                      }}
                      className="asc-label-top projectNameText z-3"
                    >
                      {/* Notes */}
                      {t("Notes")}
                    </label>

                    <textarea
                      style={{
                        marginTop: "6px",
                        position: "relative",
                        zIndex: 2,
                      }}
                      id="w3review"
                      name="w3review"
                      rows="4"
                      cols="50"
                      // placeholder="Notes"
                      className="notesInput ps-3 bordered-inputs"
                      value={notes}
                      onChange={(e) => {
                        // setChangeComp(e.target.value);
                        setNotes(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>

                <div className="col-4 mobile-full-width">
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Client */}
                      {t("Client")}
                      <span className="mandatory-sign">*</span>
                    </label>

                    <div
                      ref={clientPopRef}
                      className="clientInput"
                      style={{
                        height: "247px",
                        border: clientNameWarning
                          ? "0.5px solid red"
                          : "1px solid #70707080",
                      }}
                    >
                      <input
                        type="text"
                        placeholder={t("Select a client")}
                        className="clientText bordered-inputs ps-3"
                        style={{ width: "95%" }}
                        value={searchName}
                        // onClick={() => {
                        //   setShowOptions((prev) => !prev);
                        // }}
                        onChange={(e) => {
                          setSearchName(e.target.value.toLowerCase());
                          setShowOptions(true);
                        }}
                        // onFocus={onInputFocus}
                        onFocus={() => {
                          if (searchName === "") {
                            setShowOptions(true);
                          }
                        }}
                        // onMouseEnter={() => {
                        //     setShowOptions(true);
                        // }}
                      />

                      {searchName || showOptions ? (
                        <img
                          src={Xicon}
                          className="xicon pointer"
                          alt=""
                          onClick={() => {
                            setClientid("");
                            setSearchName("");
                            setClientAddress("");
                            setProfessionalAddress("");
                            setPersonalAddress("");
                            setZipCode("");
                            setCountry("");
                            setCity("");
                            // setShowOptions(!showOptions);
                            setShowOptions(false);
                            window.localStorage.setItem("clientid", "");
                            window.localStorage.setItem("clientname", "");
                          }}
                        />
                      ) : (
                        ""
                      )}

                      <div
                        style={{
                          height: "120px",
                          maxHeight: "120px",
                          overflow: "auto",
                        }}
                      >
                        <p className="pt-3 ps-3 mb-1 clientAddress">
                          {clientAddress ||
                            professionalAddress ||
                            personalAddress}
                        </p>

                        <div className="d-flex gap-1 clientAddress">
                          <p>{zipCode}</p>
                          <p> {city}</p>
                          <p>{country}</p>
                        </div>
                      </div>

                      {showOptions && (
                        <div
                          className="customSelect_Outer"
                          style={{
                            top: "45px",
                            height: "max-content",
                            width: "98%",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            id="ascSelectBox"
                            style={{
                              overflow: "auto",
                              minHeight: "130px",
                              maxHeight: "160px",
                              height: "auto",
                            }}
                          >
                            {clientData
                              .filter((item) =>
                                item.name?.toLowerCase().includes(searchName),
                              )
                              .map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="customSelect ulterDrop"
                                    onClick={() => {
                                      setSearchName(item.name);
                                      setClientid(item.id);
                                      setClientAddress(
                                        item.address ||
                                          item.personalAddress ||
                                          item.professionalAddress,
                                      );
                                      setProfessionalAddress(
                                        item.professionalAddress,
                                      );
                                      setPersonalAddress(item.personalAddress);
                                      setAddressWithPinCode(
                                        item.address ||
                                          item.personalAddress ||
                                          item.professionalAddress,
                                      );
                                      setZipCode(item.zipCode);
                                      setCity(item.city);
                                      setCountry(item.country);
                                      setShowOptions(false);
                                      setClientNameWarning(false);
                                      setCreditLimit(item.creditLimit);
                                      if (item.type === "Client") {
                                        dispatch(
                                          FetchClientContactsByclientId(
                                            item.id,
                                          ),
                                        );
                                      }
                                      if (item.type === "Contact") {
                                        setMainContact(item.name);
                                        setMainContactID(item.id);
                                        setContactEmail(item.email);
                                        setContactTelephone(item.phoneNumber);
                                      }

                                      setDeliveryAddress(
                                        `${
                                          item.address ||
                                          item.personalAddress ||
                                          item.professionalAddress
                                        }`,
                                      );
                                      setTypeComp("asc");
                                      window.localStorage.setItem(
                                        "clientid",
                                        item.id,
                                      );
                                      window.localStorage.setItem(
                                        "clientname",
                                        item.name,
                                      );
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                );
                              })}
                          </div>
                          {clientData.filter((item) =>
                            item.name?.toLowerCase().includes(searchName),
                          ).length === 0 && (
                            <span className="noDataDisplay ps-3">
                              {/* No data to display! */}
                              {t("No data to display!\n")}
                            </span>
                          )}

                          <p
                            className="addbilling mb-0 ps-3 py-2"
                            onClick={() => {
                              history.push("/add-company");
                              localStorage.setItem(
                                "projectOnTheFly",
                                "projectOnTheFly",
                              );
                            }}
                          >
                            {/* Add New */}
                            {t("Add New")}
                          </p>
                        </div>
                      )}

                      <div className="creditLimit mt-3 me-3 pt-2">
                        <div>
                          <p className="mb-0">
                            {/* Credit Limit */}
                            {t("Credit Limit")}
                          </p>

                          <CurrencyInput
                            className="ps-3 fw-normal"
                            style={{
                              border: "none",
                              width: "100px",
                              color: "#A5A5A5",
                            }}
                            placeholder="0"
                            name="creditBalance"
                            value={creditLimit}
                            onChangeEvent={(event, maskedValue, floatValue) => {
                              setCreditLimit(floatValue);
                            }}
                            decimalSeparator=","
                            thousandSeparator="."
                            precision="2"
                            // for normal input👇
                            // decimalSeparator=""
                            // thousandSeparator=""
                            // precision=""
                            // for normal input👆
                            allowEmpty={true}
                            prefix="€ "
                          />
                        </div>

                        <div>
                          <p className="mb-0">
                            {/* Balance */}
                            {t("Balance")}
                          </p>
                          <p className="mb-0 fw-normal">
                            {europeanFormatWithSymbol(creditBalance)}
                          </p>
                        </div>

                        <div>
                          <p className="mb-0">
                            {/* Status */}
                            {t("Status")}
                          </p>
                          <div className="assignment_radio pointerEvent">
                            <input
                              type="radio"
                              checked={creditStatus}
                              style={{
                                width: "20px",
                                height: "20px",
                                background:
                                  creditLimit > creditBalance ? "red" : "green",
                              }}
                              value={creditStatus}
                              onClick={(e) => {
                                setCreditStatus(!creditStatus);
                                setTypeComp(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {clientNameWarning && (
                    <h6 className="warningText">
                      {/* Please select a client */}
                      {t("Please select a client")}
                    </h6>
                  )}

                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Contact for Delivery */}
                      {/* Main Contact */}
                      {t("Main Contact")}
                    </label>
                    <input
                      type="text"
                      readOnly
                      style={{ cursor: "pointer" }}
                      className="contactDeliveryInput ps-4 bordered-inputs"
                      placeholder={t("Add a contact name")}
                      value={mainContact}
                      onChange={(e) => {
                        // setChangeComp(e.target.value);
                        setMainContact(e.target.value);
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          setMainContactDataOpen(false);
                        }, 500);
                      }}
                      onClick={() => {
                        setMainContactDataOpen(!mainContactDataOpen);
                      }}
                    />

                    {mainContactDataOpen && (
                      <div
                        className="userDataSelectBox ps-0"
                        style={{
                          position: "absolute",
                          top: "55px",
                        }}
                      >
                        <div className="userDataOptionDiv py-2">
                          {mainContactData.map((user, userIndex) => {
                            return (
                              <div
                                className={
                                  selectedUserID === user.contactId
                                    ? "selectedDat-a ulterDrop"
                                    : "userDataOptio-n ulterDrop"
                                }
                                onClick={() => {
                                  setMainContact(user.fullName);
                                  setMainContactID(user.contactId);
                                  setContactEmail(user.email);
                                  setContactTelephone(user.phoneNo);
                                  setMainContactDataOpen(false);
                                }}
                              >
                                <p className="mb-0">{user.fullName}</p>
                              </div>
                            );
                          })}
                          {mainContactData.length === 0 && (
                            <p className="text-center mb-1 p-3 ">
                              No contacts available
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Contact Email */}
                      {t("Contact Email")}
                    </label>
                    <input
                      type="text"
                      // readOnly
                      style={{ pointerEvents: "none" }}
                      className={
                        !emailInvalid22?.test(contactEmail) && contactEmail
                          ? "warning-border ps-4 bordered-inputs"
                          : "contactDeliveryInput ps-4 bordered-inputs"
                      }
                      placeholder={t("Add an email")}
                      value={contactEmail}
                      onChange={(e) => {
                        // setChangeComp(e.target.value);
                        setContactEmail(e.target.value);
                        setEmailInvalid(false);
                      }}
                    />
                    {emailInvalid && (
                      <div
                        className="ps-1"
                        style={{ color: "red", fontSize: "14px" }}
                      >
                        <i className="pe-1 bi bi-exclamation-circle"></i>
                        {/* Email is invalid */}
                        {t("Email is invalid\n")}
                      </div>
                    )}
                  </div>

                  <div className="asc-input-container mb-" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Contact Telephone */}
                      {t("Contact Telephone")}
                    </label>

                    <PhoneInput
                      country={"nl"}
                      enableSearch={true}
                      style={{ pointerEvents: "none" }}
                      className="pt-1 contactDeliveryInput ps-4 bordered-inputs"
                      placeholder="Contact Telephone"
                      value={contactTelephone}
                      onChange={(phone) => {
                        setContactTelephone(phone);
                        // setChangeComp(phone);
                      }}
                      // defaultCountry={'in'}
                      // inputProps={{
                      //   name: 'phone',
                      //   required: true,
                      //   autoFocus: true,
                      // }}
                    />
                  </div>

                  <div className="asc-input-container newMargin" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Project Manager */}
                      {t("Project Manager")}
                    </label>

                    <div
                      className="projectManagerInput ps-4 d-flex align-items-center"
                      ref={projectManagerRef}
                    >
                      {/* Normal select start */}

                      {/* <select
                        className="selectBox ps-2"
                        value={projectManagerid}
                        onChange={(e) => {
                          setProjectManagerid(e.target.value);
                        }}
                      >
                        <option className="pointerNone" value="">
                          Select Manager
                        </option>
                        {projectManagerData.map((item, index) => (
                          // <option value={item.userid}>{item.name}</option>
                          <option value={item.userid}>
                            {`${item.firstname} ${item.lastname}`}
                          </option>
                        ))}
                      </select> */}

                      {/* Normal select end */}

                      {showplusCircle && (
                        <img
                          src={plusCircle}
                          className="projectPlusImg pointer"
                          alt=""
                          onClick={(e) => {
                            setManagerShowBox(true);
                            setShowDropPeople(!showDropPeople);
                          }}
                        />
                      )}

                      {showImgCircle && (
                        <>
                          {managerImageurl ? (
                            <img
                              src={managerImageurl}
                              className="managerImg pointer"
                              alt=""
                              onClick={(e) => {
                                setManagerShowBox(true);
                                setShowDropPeople(!showDropPeople);
                              }}
                            />
                          ) : (
                            <div
                              className="selectedImg pointer"
                              onClick={(e) => {
                                setManagerShowBox(true);
                                setShowDropPeople(!showDropPeople);
                              }}
                            >
                              {managerLastname
                                ? managerFirstName[0]?.toUpperCase() +
                                  "" +
                                  managerLastname[0]?.toUpperCase()
                                : managerFirstName?.slice(0, 2).toUpperCase()}
                            </div>
                          )}

                          <p className="pt-3 managerText ps-2">
                            {managerFirstName} {managerLastname}
                          </p>
                        </>
                      )}

                      {/*////// ASC WITH IMG SELECT BOX START //////*/}

                      <div className="gap-2 mt-2 me-2 d-flex">
                        {showDropPeople && (
                          <div
                            className="withImgSelectBox w-100"
                            id="ascSelectBox"
                            style={{ zIndex: "1", top: "-23px", left: "0%" }}
                          >
                            <div class="search_Div_People">
                              <input
                                type="text"
                                className="search_People_Input"
                                placeholder="Search"
                                value={searchPeople}
                                onChange={(e) => {
                                  setSearchPeople(e.target.value);
                                }}
                              />
                            </div>

                            {projectManagerData
                              ?.filter(
                                (item) =>
                                  item.firstname
                                    ?.toLowerCase()
                                    .includes(searchPeople) ||
                                  item.lastname
                                    ?.toLowerCase()
                                    .includes(searchPeople),
                              )
                              .map((people, index) => {
                                let existItem = false;
                                if (projectManagerid === people.userid) {
                                  existItem = true;
                                }
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      backgroundColor: existItem
                                        ? "#e4e4e4"
                                        : "",
                                    }}
                                    className="dropDown_peoples_flex py-2 m-0 w-100 ulterDrop"
                                    onClick={() => {
                                      setManagerImageurl(people.imageurl);
                                      setManagerFirstName(people.firstname);
                                      setManagerLastname(people.lastname);
                                      setProjectManagerid(people.userid);
                                      setShowImgCircle(true);
                                      setTypeComp("asc");

                                      if (
                                        assignee?.find(
                                          (item) =>
                                            item.assigneeid === people.userid,
                                        )
                                      ) {
                                        let data = [...assignee];
                                        data = data.filter((item) => {
                                          return (
                                            item.assigneeid !== people.userid
                                          );
                                        });
                                        setAssignee(data);
                                      } else {
                                        const assigneeid = people.userid;
                                        const imageurl = people.imageurl;
                                        const firstname = people.firstname;
                                        const lastname = people.lastname;
                                        setAssignee([
                                          ...assignee,
                                          {
                                            assigneeid,
                                            imageurl,
                                            firstname,
                                            lastname,
                                          },
                                        ]);
                                        setShowDropPeople(false);
                                      }
                                    }}
                                  >
                                    {people.imageurl ? (
                                      <img
                                        src={people.imageurl}
                                        className="dropDownImg"
                                        alt=""
                                      />
                                    ) : (
                                      <div className="dropDownImg">
                                        {people?.lastname
                                          ? people?.firstname[0]?.toUpperCase() +
                                            "" +
                                            people?.lastname[0]?.toUpperCase()
                                          : people?.firstname
                                              ?.slice(0, 2)
                                              .toUpperCase()}
                                      </div>
                                    )}

                                    <p className="dropDownPeople-s m-0">
                                      {people?.firstname} {people?.lastname}
                                    </p>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>

                      {/*////// ASC WITH IMG SELECT BOX END //////*/}
                    </div>
                  </div>
                </div>

                <div className="col-4 mobile-full-width">
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Status */}
                      {t("Status")}
                    </label>

                    <div className="projectManagerInput">
                      {/* <select
                        className="selectBox22"
                        value={statusPipeLine}
                        onChange={(e) => {
                          setStatusPipeLine(e.target.value);
                          setTypeComp(e.target.value);
                        }}
                      >
                        {(isBuildingBlock ? statusOption1 : statusOption).map(
                          (items) => (
                            <option key={items.id} value={items.value}>
                              {items.label}
                            </option>
                          )
                        )}
                      </select> */}

                      <searchSection>
                        <div
                          className="asc_Search_Box d-flex"
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                          }}
                          ref={Project_Popup_Ref}
                        >
                          <p
                            className="asc_Client_Input_For_Long ps-3"
                            style={{ width: "93%" }}
                            onClick={() => {
                              setProjectShowOptions(true);
                              setArrowOptionsRotate(true);
                            }}
                          >
                            {statusPipeLineLabel
                              ? statusPipeLineLabel
                              : "Select PipeLine"}
                          </p>

                          {statusPipeLine ? (
                            <img
                              src={Xicon}
                              className="xicon pointer mt-1"
                              alt=""
                              onClick={() => {
                                setProjectShowOptions(!projectShowOptions);
                                setArrowOptionsRotate(!arrowOptionsRotate);
                                setTypeComp("asc");
                                if (showAdvancedTaskSystem) {
                                  setStatusPipeLineLabel(
                                    projectStatusList[0]?.statusName,
                                  );
                                  setStatusPipeLine(
                                    projectStatusList[0]?.statusId,
                                  );
                                  return;
                                }
                                setStatusPipeLineLabel("Info Request");
                                setStatusPipeLine(
                                  process.env.REACT_APP_PROJECT_INFO_REQUEST,
                                );
                              }}
                            />
                          ) : (
                            <img
                              src={DownArrowOption}
                              className={
                                arrowOptionsRotate
                                  ? "upArrow mt-1"
                                  : "downArrow mt-1"
                              }
                              alt=""
                              onClick={() => {
                                setProjectShowOptions(!projectShowOptions);
                                setArrowOptionsRotate(!arrowOptionsRotate);
                              }}
                            />
                          )}

                          {projectShowOptions && (
                            <div
                              className="asc_Custom_Select_Outer pt-2"
                              style={{
                                borderTop: "none",
                                borderRadius: "none",
                                boxShadow: "none",
                                background: "white",
                                zIndex: "2",
                              }}
                            >
                              {showAdvancedTaskSystem ? (
                                <section
                                  className="asc_Search_List pt-0 ps-0"
                                  style={{ maxHeight: "125px" }}
                                  id="ascSelectBox"
                                >
                                  {projectStatusList?.map((status, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="ulterDrop"
                                        onClick={() => {
                                          setStatusPipeLineLabel(
                                            status.statusName,
                                          );
                                          setStatusPipeLine(status.statusId);
                                          setProjectShowOptions(false);
                                        }}
                                      >
                                        <p
                                          className={
                                            statusPipeLine === status.statusId
                                              ? "asc_Selected_Ite-m mb-0 ps-1"
                                              : "mb-0 ps-1"
                                          }
                                          style={{
                                            boxShadow: "none",
                                          }}
                                        >
                                          {status.statusName}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </section>
                              ) : (
                                <section
                                  className="asc_Search_List pt-0"
                                  style={{ maxHeight: "125px" }}
                                  id="ascSelectBox"
                                >
                                  {(isBuildingBlock
                                    ? statusOption1
                                    : statusOption
                                  )
                                    // .filter((item) =>
                                    //   item.projectname
                                    //     ?.toLowerCase()
                                    //     .includes(searchProjectName.toLowerCase())
                                    // )
                                    .map((item, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className=""
                                          onClick={() => {
                                            // setSearchProjectName("");
                                            setStatusPipeLineLabel(item.label);
                                            setStatusPipeLine(item.value);
                                            // dispatch(FetchProjectByClient(item.id));
                                            setProjectShowOptions(false);
                                            // setTypeInScreen("asc");
                                            // setTypeComp(e.target.value);
                                          }}
                                        >
                                          <p
                                            className={
                                              statusPipeLine === item.value
                                                ? "asc_Selected_Item ps-3"
                                                : "ps-3"
                                            }
                                            style={{
                                              boxShadow: "none",
                                            }}
                                          >
                                            {item.label}
                                          </p>
                                        </div>
                                      );
                                    })}
                                </section>
                              )}
                            </div>
                          )}
                        </div>
                      </searchSection>
                    </div>
                  </div>

                  <div className="d-flex gap-3 mt-3">
                    <div className="asc-input-container w-100" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Starting Date */}
                        {t("Starting Date ")}
                      </label>
                      <div
                        className="projectManagerInput ps-4 flexContainer"
                        id="CalendarCssTT"
                        // ref={startingDate_Popup_Ref}
                      >
                        <img
                          className="calendarIcon"
                          onClick={() => setCalendarIsOpen((p) => !p)}
                          src={calendar}
                          alt=""
                        />
                        <AppDatePicker
                          open={calendarIsOpen}
                          onOpenChange={(open) => setCalendarIsOpen(open)}
                          selected={startingDate}
                          onChange={(val) => {
                            setStartingDate(val);
                            setCalendarIsOpen(false);
                          }}
                          onSelect={(d, event) => {
                            setDateError(false);
                            event.preventDefault();
                          }}
                          isError={dateError}
                          error={setDateError}
                          dateFormat="dd/MM/yyyy"
                          isDisabledForPast={true}
                        />
                      </div>
                      {dateError && (
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            marginTop: "5px",
                          }}
                        >
                          <div class="warning-icon">!</div>
                          <div class="warning-message">
                            Please select a valid date.
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="asc-input-container w-100" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Completion Date */}
                        {t("Completion Date")}
                      </label>
                      <div
                        className="projectManagerInput ps-4 flexContainer"
                        id="CalendarCssTT22"
                        // ref={complitionDate_Popup_Ref}
                      >
                        <img
                          className="calendarIcon"
                          onClick={() => setCalendarIsOpen2((p) => !p)}
                          src={calendar}
                          alt=""
                        />
                        <AppDatePicker
                          open={calendarIsOpen2}
                          onOpenChange={(open) => setCalendarIsOpen2(open)}
                          selected={completionDate}
                          onChange={(val) => {
                            setCompletionDate(val);
                            setCalendarIsOpen2(false);
                          }}
                          onSelect={(d, event) => {
                            setDateError(false);
                            event.preventDefault();
                          }}
                          isError={dateError}
                          error={setDateError}
                          dateFormat="dd/MM/yyyy"
                          minDateForPlanBoard={startingDate}
                        />
                      </div>
                      {dateError && (
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            marginTop: "5px",
                          }}
                        >
                          <div class="warning-icon">!</div>
                          <div class="warning-message">
                            Please select a valid date.
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="d-flex gap-3 mt-3">
                    <div
                      className="asc-input-container"
                      style={{ width: "100%" }}
                      id="ascInput"
                    >
                      <label className="asc-label-top projectNameText">
                        {/* No. Weeks */}
                        {t("Completion Date")}
                      </label>
                      <input
                        type="number"
                        readOnly
                        className="projectNameInput ps-4 bordered-inputs"
                        style={{ fontSize: "12px" }}
                        // placeholder="NO. Weeks"
                        placeholder={t("No. of weeks")}
                        value={numberOfWeeks}
                        onChange={(e) => {
                          setNumberOfWeeks(e.target.value);
                          setTypeComp(e.target.value);
                        }}
                      />
                    </div>

                    <div className="input_container_assign" id="ascInput">
                      <label className="asc-label-top projectNameText">
                        {/* Need PO ? */}
                        {t("Need PO ?")}
                      </label>
                      <div className="projectManagerInput ps-2 assign_Probability_project gap-3">
                        <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                          <input
                            type="radio"
                            checked={needPO === true}
                            style={{
                              fontSize: "12px",
                              width: "20px",
                              height: "20px",
                            }}
                            // value={needPO}
                            onChange={(e) => {
                              // setNeedPO(e.target.checked);
                              setNeedPO(true);
                              setTypeComp(e.target.value);
                            }}
                          />
                          {/* Yes */}
                          {t("Yes")}
                        </div>

                        <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                          <input
                            type="radio"
                            checked={needPO === false}
                            style={{
                              fontSize: "12px",
                              width: "20px",
                              height: "20px",
                            }}
                            // value={needPO}
                            onChange={(e) => {
                              // setNeedPO(e.target.checked);
                              setNeedPO(false);
                              setTypeComp(e.target.value);
                            }}
                          />
                          {/* No */}
                          {t("No")}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* assign probality start  */}
                  <div className="input_container_assign" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Assignment Probability */}
                      {t("Assignment Probablity")}
                    </label>
                    <div className="projectManagerInput ps-4 assign_Probability_project">
                      {/* High Priority */}
                      <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                        <input
                          type="radio"
                          name="priority"
                          value="high"
                          checked={
                            priorityId ===
                            process.env.REACT_APP_TASK_PRIORITY_HIGH
                          }
                          style={{
                            backgroundColor:
                              priorityId ===
                              process.env.REACT_APP_TASK_PRIORITY_HIGH
                                ? "green"
                                : "transparent",
                          }}
                          onChange={() => {
                            setPriorityId(
                              process.env.REACT_APP_TASK_PRIORITY_HIGH,
                            );
                          }}
                        />
                        {/* High */}
                        {t("High")}
                      </div>

                      {/* Medium Priority */}
                      <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                        <input
                          type="radio"
                          name="priority"
                          value="medium"
                          checked={
                            priorityId ===
                            process.env.REACT_APP_TASK_PRIORITY_NORMAL
                          }
                          style={{
                            backgroundColor:
                              priorityId ===
                              process.env.REACT_APP_TASK_PRIORITY_NORMAL
                                ? "orange"
                                : "transparent",
                          }}
                          onChange={() => {
                            setPriorityId(
                              process.env.REACT_APP_TASK_PRIORITY_NORMAL,
                            );
                          }}
                        />
                        {/* Medium */}
                        {t("Medium")}
                      </div>

                      {/* Low Priority */}
                      <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                        <input
                          type="radio"
                          name="priority"
                          value="low"
                          checked={
                            priorityId ===
                            process.env.REACT_APP_TASK_PRIORITY_LOW
                          }
                          style={{
                            backgroundColor:
                              priorityId ===
                              process.env.REACT_APP_TASK_PRIORITY_LOW
                                ? "yellow"
                                : "transparent",
                          }}
                          onChange={() => {
                            setPriorityId(
                              process.env.REACT_APP_TASK_PRIORITY_LOW,
                            );
                          }}
                        />
                        {/* Low */}
                        {t("Low")}
                      </div>
                    </div>
                  </div>
                  {/*  assign probality end*/}

                  {/* Billing start */}
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top projectNameText">
                      {/* Billing */}
                      {t("Billing")}
                    </label>

                    <div
                      className="clientInput ps-3"
                      style={{ height: "129px" }}
                    >
                      <input
                        type="text"
                        // placeholder="Select Billing"
                        placeholder={billingName === "" && t("Select Billing")}
                        className="clientText bordered-inputs"
                        style={{ width: "93%" }}
                        readOnly
                        // value={searchBillingName}
                        onClick={(e) => {
                          setShowBillingOption(true);
                        }}
                        onChange={(e) => {
                          setSearchBillingName(e.target.value.toLowerCase());
                          setShowBillingOption(true);
                        }}
                        onFocus={() => {
                          if (billingName === "") {
                            setShowBillingOption(true);
                          }
                        }}
                        // onMouseEnter={() => {
                        //     setShowOptions(true);
                        // }}
                      />

                      {billingName || showBillingOption ? (
                        <img
                          src={Xicon}
                          className="xicon pointer"
                          alt=""
                          onClick={() => {
                            setSearchBillingName("");
                            setBillingName("");
                            setBillingID("");
                            setShowBillingOption(false);
                          }}
                        />
                      ) : (
                        ""
                      )}

                      <p className="pt-3 mb-1 billingAddress">{billingName}</p>

                      {showBillingOption && (
                        <div className="billingSelect_Outer">
                          <div className="billingTerms">
                            <p className="mb-0 fw-bold">
                              {/* Billing Terms */}
                              {t("Billing Terms")}
                            </p>
                            <img
                              src={XiconCircle}
                              className="xicon pointer ms-auto"
                              style={{ width: "20px", height: "20px" }}
                              alt=""
                              onClick={() => {
                                setShowBillingOption(false);
                              }}
                            />
                          </div>

                          <div
                            className="pe-3"
                            style={{ overflow: "auto", height: "400px" }}
                          >
                            {billingData
                              .filter((item) =>
                                item.name
                                  ?.toLowerCase()
                                  .includes(searchBillingName),
                              )
                              .map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="billingRow"
                                    onClick={() => {
                                      setSearchBillingName("");
                                      setBillingName(item.name);
                                      setBillingID(item.id);
                                      setShowBillingOption(false);
                                      setTypeComp("asc");
                                    }}
                                  >
                                    <p
                                      className={
                                        billingID === item.id
                                          ? "mb-0 py-2 px-3 d-flex gap-2 billingSelected"
                                          : "mb-0 py-2 px-3 d-flex gap-2"
                                      }
                                    >
                                      <p className="mb-0">
                                        {index + 1}
                                        {"."}
                                      </p>
                                      {item.name} &nbsp;
                                      {billingID === item.id && <span>✔</span>}
                                    </p>

                                    {item.isDefault === 0 && (
                                      <Tooltip title="Delete" color={"red"}>
                                        <p
                                          className="mb-0 labelDltIcon"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch();
                                            DeleteProjectBillingTerms(item.id);
                                          }}
                                        >
                                          {/* x */}
                                          <DeleteOutlined
                                            style={{ fontSize: "14px" }}
                                          />
                                        </p>
                                      </Tooltip>
                                    )}
                                  </div>
                                );
                              })}
                          </div>

                          {/* add new billing start */}
                          <div className="p-3">
                            <p
                              className="addbilling mb-0"
                              onClick={() => {
                                setAddBillingInputShow(!addBillingInputShow);
                              }}
                            >
                              {/* Add New */}
                              {t("Add New")}
                            </p>

                            {addBillingInputShow && (
                              <div className="d-flex gap-3">
                                <div style={{ width: "90%" }}>
                                  <input
                                    type="text"
                                    autoFocus={true}
                                    className="addbilling-input py-1"
                                    value={addBilling}
                                    onChange={(e) => {
                                      setAddBilling(e.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        handleAddNewBilling();
                                      }
                                    }}
                                  />
                                </div>

                                <div className="d-flex gap-3 pointer">
                                  <Tooltip title="Add" color={"#14A44D"}>
                                    <p
                                      className="mb-0 undoIcon ms-auto"
                                      onClick={() => {
                                        handleAddNewBilling();
                                      }}
                                    >
                                      {/* ✔ */}
                                      <CheckOutlined />
                                    </p>
                                  </Tooltip>

                                  <Tooltip title="Undo" color={""}>
                                    <p
                                      className="mb-0 undoIcon"
                                      onClick={() => {
                                        setAddBilling("");
                                      }}
                                    >
                                      <UndoOutlined />
                                    </p>
                                  </Tooltip>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* add new billing end */}

                          {billingData.filter((item) =>
                            item.name
                              ?.toLowerCase()
                              .includes(searchBillingName),
                          ).length === 0 && (
                            <span className="noDataDisplay">
                              {/* No data to display! */}
                              {t("Project")}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Billing end */}

                  {/* Payment Terms start */}
                  <div className="asc-input-container" id="ascInput">
                    <label className="asc-label-top ClientNameText">
                      {/* Payment Deadline */}
                      {t("Payment Deadline")}
                    </label>
                    <div
                      className="asc_Client_Input_Div_For_LongDiv22"
                      ref={PaymentDeadline_Popup_Ref}
                      style={{ width: "auto" }}
                    >
                      <input
                        type="text"
                        className="asc_Client_Input_For_Long ps-4"
                        style={{ width: "93%" }}
                        placeholder="Immediately (0 Days)"
                        value={paymentDeadline}
                        onChange={(e) => {
                          setPaymentDeadline(e.target.value);
                          setPaymentDeadlineOptions(true);
                        }}
                        onFocus={() => {
                          setPaymentDeadlineOptions(true);
                          setArrowOptionsRotate4(true);
                        }}
                      />

                      {paymentDeadline ? (
                        <img
                          src={Xicon}
                          className="xicon pointer"
                          alt=""
                          onClick={() => {
                            setPaymentDeadline("");
                            setPaymentDeadlineid("");
                            setTypeComp("asc");
                          }}
                        />
                      ) : (
                        <img
                          src={DownArrowOption}
                          className={
                            arrowOptionsRotate4 ? "upArrow" : "downArrow"
                          }
                          alt=""
                          onClick={() => {
                            setPaymentDeadlineOptions(true);
                            setArrowOptionsRotate4(true);
                          }}
                        />
                      )}

                      {paymentDeadlineOptions && (
                        <div
                          className="asc_Custom_Select_Outer22"
                          style={{
                            transform: paymentDeadlineOptions
                              ? "scale(1)"
                              : "scale(0)",
                            transitionDuration: "300ms",
                            top: "-20px",
                          }}
                        >
                          <p className="asc_Search_Client_Text pt-2 ps-2">
                            {/* Select Payment Deadline */}
                            {t("Select Payment Deadline")}
                          </p>

                          <section
                            className="asc_Search_List pt-2 ps-0"
                            id="ascSelectBox"
                          >
                            {paymentDeadlineData.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="ulterDrop"
                                  onClick={() => {
                                    setPaymentDeadline(item.paymentDeadline);
                                    setPaymentDeadlineid(
                                      item.paymentDeadlineid,
                                    );
                                    setPaymentDeadlineOptions(false);
                                    setTypeComp("asc");
                                    if (item.paymentDeadline === "others") {
                                      setPaymentOthersOptions(true);
                                    }
                                  }}
                                >
                                  {item.paymentDeadline}
                                </div>
                              );
                            })}
                            {paymentDeadlineData.length === 0 && (
                              <span className="noDataDisplay">
                                No data to display!
                                {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                              </span>
                            )}
                          </section>
                        </div>
                      )}

                      <paymentOtherOption>
                        {paymentOthersOptions && (
                          <div className="otherPayment p-3 w-50">
                            <div>
                              <h6
                                className="xCiecle ms-auto me-1 pointer"
                                onClick={() => {
                                  setPaymentOthersOptions(false);
                                }}
                              >
                                x
                              </h6>
                            </div>
                            <div
                              className="asc-input-container mt-2"
                              id="ascInput"
                            >
                              <label className="asc-label-top ClientNameText">
                                {/* Due Days */}
                                {t("Due Days")}
                              </label>
                              <input
                                type="number"
                                className="asc_NormalInput w-100 ps-4"
                                placeholder="0"
                                value={dueDays}
                                onChange={(e) => {
                                  setDueDays(e.target.value);
                                  setTypeComp("asc");
                                }}
                              />
                            </div>

                            <div
                              className="asc-input-container mt-3"
                              id="ascInput"
                            >
                              <label className="asc-label-top ClientNameText">
                                {/* Description */}
                                {t("Description")}
                              </label>
                              <input
                                type="text"
                                className="asc_NormalInput w-100 ps-4"
                                placeholder="0 Days"
                                value={description}
                                onChange={(e) => {
                                  setDescription(e.target.value);
                                  setTypeComp("asc");
                                }}
                              />
                            </div>

                            <button
                              className="makeInvoBtn ms-1 mt-3"
                              onClick={() => {
                                // setPaymentDeadline(dueDays + "" + "Days");
                                setPaymentDeadline(`${dueDays} Days`);
                                setPaymentOthersOptions(false);
                              }}
                            >
                              {/* Add */}
                              {t("Add")}
                            </button>
                          </div>
                        )}
                      </paymentOtherOption>
                    </div>
                  </div>
                  {/* Payment Terms end */}
                </div>
              </div>
            )}

            {/* ////////// ASC GENERAL BOX END //////////// */}

            {tab === "Document" && <ProjectDocuments />}
            {tab === "Quote" && <AddQuotes />}
            {tab === "Materials" && <AddMaterials />}

            {tab === "Task" && (
              <AddTask
                val={val}
                setVal={setVal}
                isBasicMember={isBasicMember}
                setIsBasicMember={setIsBasicMember}
                isBuildingBlock={isBuildingBlock}
                setIsBuildingBlock={setIsBuildingBlock}
                statusList={statusList}
                setStatusList={setStatusList}
                modalFunction={modalFunction}
                setModalFunction={setModalFunction}
                taskid={taskid}
                setTaskid={setTaskid}
                comments={comments}
                setComments={setComments}
                maxComments={maxComments}
                setMaxComments={setMaxComments}
                show={show}
                setShow={setShow}
                setShowModal={setShowModal}
                showModal={showModal}
              />
            )}

            {/* {tab === "Proforma" && <Proforma />} */}

            {/* {tab === "Invoice" && <AddInvoice />} */}

            {/* Gaurav code for Sub Tab invoice and proforma start */}
            {/* Conditional rendering for subtabs inside "Invoice and Proformas" */}
            {tab === "Invoice and Proformas" && (
              <div className=" ">
                {/* Subtab Navigation */}
                <div className="subtab-nav d-flex">
                  <div
                    onClick={() => handleSubTabChange("Terms")}
                    className={
                      subTab === "Terms"
                        ? "box-highlighter-gt d-none"
                        : "box-non-highlighter-gt d-none"
                    }
                  >
                    <p>
                      {/* Terms */}
                      {t("Terms")}
                    </p>
                  </div>
                  <div
                    onClick={() => handleSubTabChange("Proforma")}
                    className={
                      subTab === "Proforma"
                        ? "box-highlighter-gt"
                        : "box-non-highlighter-gt"
                    }
                  >
                    <p>
                      {/* Proformas */}
                      {t("Proformas")}
                    </p>
                  </div>
                  <div
                    onClick={() => handleSubTabChange("Invoice")}
                    className={
                      subTab === "Invoice"
                        ? "box-highlighter-gt"
                        : "box-non-highlighter-gt"
                    }
                  >
                    <p>
                      {/* Invoices */}
                      {t("Invoice")}
                    </p>
                  </div>
                </div>

                {/* Subtab Content */}
                <div className="subtab-content px-4 mx-2 pb-3 pt-3">
                  {subTab === "Terms" && <AddTerms />}
                  {subTab === "Proforma" && <Proforma />}
                  {subTab === "Invoice" && <AddInvoice />}
                </div>
              </div>
            )}
            {/* Gaurav code for Sub Tab invoice and proforma end */}

            {/* {tab === "Stock" && <AddStock />} */}
            {tab === "Stock" && (
              <div className=" ">
                {/* Subtab Navigation */}
                <div className="subtab-nav d-flex">
                  <div
                    onClick={() => handleSubTabChange2("Stock")}
                    className={
                      subTab2 === "Stock"
                        ? "box-highlighter-gt"
                        : "box-non-highlighter-gt"
                    }
                  >
                    <p>
                      {/* Purchase */}
                      {t("Purchase")}
                    </p>
                  </div>
                  <div
                    onClick={() => handleSubTabChange2("Rent")}
                    className={
                      subTab2 === "Rent"
                        ? "box-highlighter-gt"
                        : "box-non-highlighter-gt"
                    }
                  >
                    <p>
                      {/* Rent */}
                      {t("Rent")}
                    </p>
                  </div>
                  <div
                    onClick={() => handleSubTabChange2("Hiring")}
                    className={
                      subTab2 === "Hiring"
                        ? "box-highlighter-gt"
                        : "box-non-highlighter-gt"
                    }
                  >
                    <p>
                      {/* Hiring */}
                      {t("Hiring")}
                    </p>
                  </div>
                </div>

                {/* Subtab Content */}
                <div className="subtab-content px-4 mx-2 pb-3 pt-3">
                  {subTab2 === "Stock" && <AddStock />}
                  {subTab2 === "Rent" && <AddProjectRent />}
                  {subTab2 === "Hiring" && <AddProjectHiring />}
                </div>
              </div>
            )}

            {tab === "Financial" && <Financial />}
            {tab === "Team" && <Team />}
            {tab === "Work" && <ProjectWork />}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <div className="buttons-mobile d-flex justify-content-centre  gap-2 ">
            <button
              type="button"
              className="canclebtn-add invite-btn-aspect-ratio  cancle-btn-aspect-ratio"
              onClick={() => {
                // if (typeComp !== "") {
                //   setModalShow(true);
                // } else {
                history.goBack();
                // }
                // setModalShow(true);
                // history.goBack();
                handleTabChange("General"); // for switch only in General tab.
              }}
            >
              {/* Cancel */}
              {t("Cancel ")}
            </button>

            <button
              disabled={dateError}
              type="button"
              className="invitebtn-add-member invite-btn-aspect-ratio"
              onClick={handleProjectAdd}
            >
              {/* Update */}

              {/* {showLoader ? (
                  <div className="gap-1 d-flex justify-content-center align-items-center">
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                    <span>Updating...</span>
                  </div>
                ) : (
                  "Update"
                )} */}
              {/* change */}
              {t("Add")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProject;
